const councilResultsInput = {
  en: {
    councilResultsInputPage: {
      loadFailed: "Failed to load data",
      selectCouncilError: "Please select a council",
      partyExceeds: "Total party votes cannot exceed valid votes",
      sumMismatch: "Valid votes + Rejected votes must equal Total votes cast",
      submitted: "Results submitted successfully! Awaiting admin approval.",
      submitFailed: "Failed to submit results",
      accessRestricted: "Access Restricted",
      accessRestrictedDesc: "Only local officers and admins can input council election results.",
      returnDashboard: "Return to Dashboard",
      title: "Submit Council Results",
      subtitleOfficer: "Input results for your assigned councils",
      subtitleAny: "Input results for any council",
      selectCouncil: "Select Council",
      assignedCount: "You have {{count}} assigned council(s)",
      availableCount: "{{count}} councils available",
      searchPlaceholder: "Search councils...",
      noCouncils: "No councils found",
      seats: "{{count}} seats",
      resultsFor: "Results for {{name}}",
      selectToEnter: "Select a council to enter results",
      selectFromList: "Select a council from the list to enter results",
      noParties: "No parties registered",
      noPartiesDesc: "Parties must be added before results can be entered",
      registeredVoters: "Registered Voters",
      totalVotesCast: "Total Votes Cast",
      validVotes: "Valid Votes",
      rejectedVotes: "Rejected Votes",
      partyVotes: "Party Votes",
      validationSummary: "Validation Summary",
      totalPartyVotes: "Total Party Votes:",
      validVotesColon: "Valid Votes:",
      difference: "Difference:",
      notesOptional: "Notes (Optional)",
      notesPlaceholder: "Any additional notes or observations...",
      submitForApproval: "Submit Results for Approval",
      reviewNotice: "Results will be reviewed by an administrator before being published"
    }
  },
  fr: {
    councilResultsInputPage: {
      loadFailed: "Échec du chargement des données",
      selectCouncilError: "Veuillez sélectionner une commune",
      partyExceeds: "Le total des voix des partis ne peut pas dépasser les votes valides",
      sumMismatch: "Les votes valides + les votes rejetés doivent être égaux au total des votes exprimés",
      submitted: "Résultats soumis avec succès ! En attente de l'approbation de l'administrateur.",
      submitFailed: "Échec de la soumission des résultats",
      accessRestricted: "Accès restreint",
      accessRestrictedDesc: "Seuls les agents locaux et les administrateurs peuvent saisir les résultats des élections municipales.",
      returnDashboard: "Retour au tableau de bord",
      title: "Soumettre les résultats municipaux",
      subtitleOfficer: "Saisissez les résultats de vos communes assignées",
      subtitleAny: "Saisissez les résultats de n'importe quelle commune",
      selectCouncil: "Sélectionner une commune",
      assignedCount: "Vous avez {{count}} commune(s) assignée(s)",
      availableCount: "{{count}} communes disponibles",
      searchPlaceholder: "Rechercher des communes...",
      noCouncils: "Aucune commune trouvée",
      seats: "{{count}} sièges",
      resultsFor: "Résultats pour {{name}}",
      selectToEnter: "Sélectionnez une commune pour saisir les résultats",
      selectFromList: "Sélectionnez une commune dans la liste pour saisir les résultats",
      noParties: "Aucun parti enregistré",
      noPartiesDesc: "Des partis doivent être ajoutés avant de pouvoir saisir les résultats",
      registeredVoters: "Électeurs inscrits",
      totalVotesCast: "Total des votes exprimés",
      validVotes: "Votes valides",
      rejectedVotes: "Votes rejetés",
      partyVotes: "Voix par parti",
      validationSummary: "Résumé de validation",
      totalPartyVotes: "Total des voix des partis :",
      validVotesColon: "Votes valides :",
      difference: "Différence :",
      notesOptional: "Notes (facultatif)",
      notesPlaceholder: "Notes ou observations supplémentaires...",
      submitForApproval: "Soumettre les résultats pour approbation",
      reviewNotice: "Les résultats seront examinés par un administrateur avant d'être publiés"
    }
  }
};

export default councilResultsInput;
